import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StaticTextService, AboutService ,AuthService, ConfigService} from '../../services';
import { Router ,ActivatedRoute} from '@angular/router';
import { BrowserModule, Title } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ReactiveFormsModule,FormsModule,FormGroup,FormControl,Validators,FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PendingApprovalService } from '../pending-approval/pending-approval-service.service';
import { CookieService } from 'ngx-cookie';


@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TermsComponent implements OnInit {
  //innerText:String = ''
  eula:any={}
  sanitizedEulaText: SafeHtml;
  isAccept:boolean=false;
  errorMsg:any={};
  timer:any;
  constructor(
    public text:StaticTextService,
    private route:ActivatedRoute,
    private router:Router,
    private aboutService: AboutService,
    private auth:AuthService,
    private config:ConfigService,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private pendingApprovalService: PendingApprovalService,
    private cookies : CookieService
  ) { }

  ngOnInit() {
    // this.pages.getWithToken('terms').subscribe((res)=>{
    //   this.innerText = res.Page_Text;
    // });
    this.titleService.setTitle(`Pippin Title™ - Client - Terms and Conditions`)
    if(this.route.snapshot.params['userId']){
      this.isAccept=true;         
      this.aboutService.getActiveEULA()
      .subscribe((data)=>{
        if(data){
          this.eula=data;
          this.sanitizedEulaText = this.sanitizer.bypassSecurityTrustHtml(this.eula.EULA_Text);
        }
      })
    }else{
      this.aboutService.getEULAByUserId(this.auth.getUserId())
      .subscribe((data)=>{
        if(data){
          this.eula=data;
          this.sanitizedEulaText = this.sanitizer.bypassSecurityTrustHtml(this.eula.EULA_Text);
        }
      })
    }
    this.timer=setTimeout(() => this.config.setSideBarNode(0), 0);
  }

  ngOnDestroy(){
    if(this.timer)clearTimeout(this.timer)
  }

  updateUserEULA(){
    var data={
      EULA_Version:this.eula.EULA_Version
    }
    this.aboutService.updateUserEULA(this.route.snapshot.params['userId'],data)
    .subscribe((response)=>{
      let obj = {};
      this.auth.showLoggedInProfile();
      if(this.auth.getUserId()) {
        obj['User_ID'] = this.auth.getUserId();
      } else { 
        obj['User_ID'] = this.route.snapshot.params['userId'];
      }
      obj['NPS_Rating_Category'] = 0;       // portal - 0; Email - 1     
      obj['NPS_Rating_Acceptance'] = 0;     //Acceptanced - 1, Decliend - 0
      obj['NPS_Rating_Value'] = null;
      // if(!response.isApproved){
      //   this.router.navigate(['pendingApproval/' + obj['User_ID']]).then();
      //   return;
      // }
      if(!response.isMultiCliLogin) {
        this.pendingApprovalService.checkIfOnboardingComplete(response.CompanyAccounts[0] ? response.CompanyAccounts[0] : null).subscribe((res) => {
        if(!res.isOnboardingComplete){ 
            this.router.navigate(['pendingApproval/' + this.auth.getUserId() ? this.auth.getUserId() : this.route.snapshot.params['userId']]).then();
            return;
          }
        })
      }
      this.aboutService.updateUserRating(obj)
        .subscribe((data) => {
          this.moveToCurrentOrderListing();
        }, (err) => {
          this.moveToCurrentOrderListing();          
        })      
    },(err)=>{
      
      this.errorMsg=err;
    })
  }

  moveToCurrentOrderListing(){
      const cookie = this.auth.getFullCookie();
      if (cookie && cookie.user) {
          cookie.user.User_Code = 1; // Mark as active/approved
          this.cookies.put('pippinTitleUsr', JSON.stringify(cookie));
      }
      this.router.navigate(['orders/current']); 
  }

 }
